import React, { useState, useEffect } from 'react'
import { Radio, Select, Typography } from 'antd-v4'
import { ILocationContract } from '@getgreenline/locations/build/models'
const { Text } = Typography
export interface ICRSALocations {
  crsa: string
  locations: ILocationContract[]
}

export interface IOnSelect {
  crsa: string
  crsaLocation?: ICRSALocations
}

export interface IBlazeLocationSelector {
  locations: ILocationContract[]
  label?: string
  onSelect: (props: IOnSelect) => void
  disabledCRSALocations?: string[]
  value?: string
}

export const BlazeCRSALocationSelector = (props: IBlazeLocationSelector) => {
  const { locations, onSelect, disabledCRSALocations, label, value } = props
  const [selectedItemId, setSelectedItemId] = useState<string>()
  const disabledCSRA = disabledCRSALocations || []

  useEffect(() => {
    if (!value) setSelectedItemId(undefined)
  }, [value])

  const groupLocationsByCRSA = (locationsWithCRSA: ILocationContract[]) => {
    const crsaMap = new Map<string, ICRSALocations>()

    for (const location of locationsWithCRSA) {
      if (!location.storeId) continue
      const crsa = location.storeId

      let crsaGroup = crsaMap.get(crsa)
      if (!crsaGroup) {
        crsaGroup = {
          crsa,
          locations: [],
        }
        crsaMap.set(crsa, crsaGroup)
      }

      crsaGroup.locations.push(location)
    }

    return crsaMap
  }

  const groupedCRSALocations: Map<string, ICRSALocations> = groupLocationsByCRSA(locations)

  return (
    <Select
      className='gr-filter-item gr-filter-gutter'
      value={value}
      placeholder={label || 'Select a CRSA number'}
      onChange={(value) => {
        onSelect({
          crsa: value,
          crsaLocation: groupedCRSALocations.get(value),
        })
        setSelectedItemId(value)
      }}
    >
      {[...groupedCRSALocations.values()].map((crsaLocation: ICRSALocations) => {
        return (
          <Select.Option
            disabled={disabledCSRA.includes(crsaLocation.crsa)}
            key={crsaLocation.crsa}
            value={crsaLocation.crsa}
            label={crsaLocation.crsa}
          >
            <Radio
              key={crsaLocation.crsa}
              disabled={disabledCSRA.includes(crsaLocation.crsa)}
              checked={selectedItemId === crsaLocation.crsa}
            >
              {crsaLocation.crsa}
            </Radio>
            <div className='ml-4 text-muted'>
              {crsaLocation.locations.map((location) => {
                return (
                  <li key={location.id}>
                    <Text
                      className='text-muted'
                      style={{ maxWidth: 150, marginBottom: -10, marginTop: -10 }}
                      ellipsis={true}
                    >
                      {location.name}
                    </Text>
                  </li>
                )
              })}
            </div>
          </Select.Option>
        )
      })}
    </Select>
  )
}
